import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * PushNavListener — ascolta i messaggi `epicflow-nav` dal service worker
 * (dispatchati quando l'utente clicca una notifica push) e naviga
 * client-side via react-router.
 *
 * Serve principalmente per iOS PWA e Safari, dove `client.navigate()`
 * dal service worker NON è supportato: il fallback è portare il focus
 * sulla tab esistente e inviare un postMessage che il frontend gestisce.
 *
 * Deve essere montato DENTRO `<BrowserRouter>` per usare `useNavigate`.
 */
export default function PushNavListener() {
  const nav = useNavigate();
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    const onMsg = (e) => {
      const data = e?.data || {};
      if (data?.type !== "epicflow-nav") return;
      // Se il SW ha già navigato tramite client.navigate() (Chrome desktop),
      // non facciamo nulla per evitare doppio push nella history.
      if (data.already_navigated) return;
      const path = data.path || "/area-cliente";
      const search = data.search || "";
      nav(`${path}${search}`, { replace: false });
    };
    navigator.serviceWorker.addEventListener("message", onMsg);
    return () => {
      try { navigator.serviceWorker.removeEventListener("message", onMsg); } catch (_) { /* noop */ }
    };
  }, [nav]);
  return null;
}
